import store from "@/app/store";
import BasePath from "./BasePath";

export default class AuthorizedPath extends BasePath {
    constructor(primary: string) {
        super(primary, true);
    }

    // @ts-ignore
    public get authorizationToken(): string {
        return store.getters["main/getAccessToken"];
    }

    public set authorizationToken(value: string) {}
}
